import React from "react";
import SubTasksGrid from "../../components/subTasksGrid/SubTasksGrid";
import SignersList from "../../components/signersList/SignersList";
import ChatWindow from '../../components/chatWindow/chatWindow';
import Button from 'devextreme-react/button';
import './signatures.css'
import ValidationMessage from "../../components/validationMessage/ValidationMessage ";
// import UploadPopup from "../../components/fileUpload/UploadPopup";
const { REACT_APP_SERVER_URL } = process.env;




class App extends React.Component {
  constructor(props) {
    super(props);
    this.isRefreshAllowed = false;
    this.state = {
      dataFromServer: apiData,
      dcommentsFromServer: [],
      comments: [],
      crmType: "",
      taskValidation: null,
      AttachementLink: null,
      subtasks: [],
      signersCheckList: [],
      task_id: "",
      document_id: "",
      isClientCommented: false,
      task_name: "",
      unauthorizedFlag: false,
      isNextSignerBlocked:false
    };
    this.fetchDataFromServer = this.fetchDataFromServer.bind(this);
    this.fetchCommentsFromServer = this.fetchCommentsFromServer.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.displayDate = this.displayDate.bind(this);
    this.fetchDataFromServer();
    this.fetchCommentsFromServer();
    this.fetchTask();
    this.rearrangeArrayByDateCreated();
    this.rearrangeArrayById();
    this.GetClickUpData = this.GetClickUpData.bind(this);
    this.extractCustomFieldFromTask = this.extractCustomFieldFromTask.bind(this);
    this.extractSubTaksFromTask = this.extractSubTaksFromTask.bind(this);
    this.extractSignersCheckListFromTask = this.extractSignersCheckListFromTask.bind(this);




  }
  componentDidMount() {
    this.dataFetchIntervalId = setInterval(this.refreshData, 3000);
    document.addEventListener('visibilitychange', this.handleBrowserTabChange);
  }

  componentWillUnmount() {
    clearInterval(this.dataFetchIntervalId);
    document.removeEventListener('visibilitychange', this.handleBrowserTabChange);
  }

  clearDataFetchInterval = () => {
    setTimeout(() => {
      clearInterval(this.dataFetchIntervalId);
    }, 6500); // Wait for 5000 milliseconds (5 seconds)
  }

  render() {
    // if (this.state.crmType == "wr") {
    //   //if using wrike
    //   return (
    //     <React.Fragment>
    //       <h2>חתימות 📝</h2>
    //       <div className={"content-block dx-card responsive-paddings"}>
    //         {this.state.dataFromServer.map((data) => {
    //           if (data.name)
    //             if (!data.name.includes("CoSign"))
    //               return (
    //                 <div>
    //                   <p>
    //                     <b>{data.display_name}</b>
    //                   </p>
    //                   <a href={data.url} rel="noopener" target="_blank">
    //                     לחץ כאן לחתימה
    //                   </a>{" "}
    //                 </div>
    //               );
    //         })}
    //       </div>

    //       <h2>עדכונים </h2>
    //       <div className={"content-block dx-card responsive-paddings"}>
    //         {this.state.dcommentsFromServer.map((data) => (
    //           <div>
    //             <p>
    //               <b>{this.displayDate(data.createdDate)}</b>
    //             </p>
    //             <p>{data.text}</p>
    //           </div>
    //         ))}
    //       </div>
    //     </React.Fragment>
    //   );
    // } else {
      return this.GetClickUpData();
    // }
  }
  
  displayDate = (dateString) => {
    const javaScriptRelease = new Date(Date.parse(dateString));
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    return javaScriptRelease.toLocaleString("he-He", options);
  };

  fetchDataFromServer = () => {
    if (this.isRefreshAllowed) {
      const wrikeId = this.props.location.search;
      fetch(`${REACT_APP_SERVER_URL}signatures${wrikeId}&s=s`, {
        method: "GET",
        credentials: "include",
      })
        .then((response) => {
          if (response.status === 401) {
            // Unauthorized response
            this.setState({ unauthorizedFlag: true });
            console.error('Unauthorized access - status code 401');
            throw new Error('Unauthorized');
          }
          return response.json();
        })
        .then((response) => {
          if (response != "") {
            this.setState({
              dataFromServer: response.ListToSign,
              isNextSignerBlocked: response.isNextBlocked
            });
          }
        })
        .catch((error) => {
          if (error.message === 'Unauthorized') {
            console.error('Unauthorized access error:', error);
          }
          else
            // Log all errors including unauthorized access errors
            console.error('Error fetching task:', error);
        });
    }
  };


  rearrangeArrayById(comments) {
    // Sort the array based on the date_created property in descending order
    comments?.sort((a, b) => parseInt(b.id) - parseInt(a.id));
    return comments;
  }


  fetchCommentsFromServer = () => {
    if (this.isRefreshAllowed) {
      const wrikeId = this.props.location.search;
      fetch(`${REACT_APP_SERVER_URL}signatures${wrikeId}&s=c`, {
        method: "GET",
        credentials: "include",
      })
        .then((response) => {
          if (response.status === 401) {
            // Unauthorized response
            this.setState({ unauthorizedFlag: true });
            console.error('Unauthorized access - status code 401');
            throw new Error('Unauthorized');
          }
          return response.json();
        })
        .then((response) => {
          let rearragendComments = this.rearrangeArrayById(response.comments);

          this.setState({
            dcommentsFromServer: response.data,
            comments: rearragendComments,
            crmType: wrikeId.slice(-2),
          });
        })
        .catch((error) => {
          if (error.message === 'Unauthorized') {
            console.error('Unauthorized access error:', error);
          }
          else
            // Log all errors including unauthorized access errors
            console.error('Error fetching task:', error);
        });
    }
  };



  extractLimitedChoiseCfFromTask(response, customFieldName) {
    var cf = response.custom_fields?.filter(x => x.name === customFieldName)[0];
    if (cf?.value != undefined) {
      return cf.type_config?.options[cf.value]?.name;
    }
    return null;
  }

  extractCustomFieldFromTask(response, customFieldName) {
    var cf = response.custom_fields?.filter(x => x.name === customFieldName)[0];
    if (cf?.value != undefined) {
      return cf.value;
    }
    return null;
  }


  extractSubTaksFromTask(response) {
    var subtasks = response.subtasks
    if (subtasks != undefined) {
      return subtasks
    }
    return null;
  }

  rearrangeArrayByDateCreated(checklistItems) {
    // Sort the array based on the date_created property in descending order
    checklistItems?.sort((a, b) => parseInt(b.date_created) - parseInt(a.date_created));
    return checklistItems;
  }

  extractSignersCheckListFromTask(response) {
    var signersCheckList = this.rearrangeArrayByDateCreated(response?.checklistItems);

    if (signersCheckList != undefined) {
      return signersCheckList.reverse();
    }
    return null;
  }


  fetchTask() {
    if (this.isRefreshAllowed) {
      const taskId = this.props.location.search;

      fetch(`${REACT_APP_SERVER_URL}signatures${taskId}&s=t`, {
        method: "GET",
        credentials: "include",
      })
        .then((response) => {
          if (response.status === 401) {
            // Unauthorized response
            this.setState({ unauthorizedFlag: true });
            console.error('Unauthorized access - status code 401');
            throw new Error('Unauthorized');
          }
          return response.json();
        })
        .then((response) => {
          var errorIndicationValue = this.extractLimitedChoiseCfFromTask(response, "Error Indication");
          var subTasks = this.extractSubTaksFromTask(response);
          var singningCheckList = this.extractSignersCheckListFromTask(response);
          var taskId = response.id;
          var taskName = response.name;
          var isClient_commented = this.extractCustomFieldFromTask(response, "לקוח הגיב");
          var documentId = this.extractCustomFieldFromTask(response, "Reach Session Id");
          var date_created = this.displayDate(new Date(response.date_created * 1));
          var due_date = this.displayDate(new Date(response.due_date * 1));

          this.setState({
            taskValidation: errorIndicationValue,
            subtasks: subTasks,
            signersCheckList: singningCheckList,
            task_id: taskId,
            task_name: taskName,
            isClientCommented: isClient_commented,
            document_id: documentId
          });

          try {
            var attacmentPdf = response.attachments.filter(x => x.title.includes("pdf"))[0].url_w_host;
            this.setState({ AttachementLink: attacmentPdf });
          } catch (error) {
            // Handle any errors with fetching the attachment
            console.error('Error fetching attachment:', error);
          }
        })
        .catch((error) => {
          if (error.message === 'Unauthorized') {
            console.error('Unauthorized access error:', error);
          }
          else
            // Log all errors including unauthorized access errors
            console.error('Error fetching task:', error);


        });
    }
  }







  handleClick = (signingLink) => {
    window.open(signingLink, '_blank')
  };

  handleBrowserTabChange = () => {
    this.refreshData();
    setTimeout(() => { this.refreshData() }, 8000);
  }

  refreshData = () => {
    this.isRefreshAllowed = true;
    this.fetchDataFromServer();
    this.fetchCommentsFromServer();
    this.fetchTask();
    this.isRefreshAllowed = false;
  };

  GetClickUpData = () => {
    //if using wrike
    return (
      <React.Fragment>
        {this.state.unauthorizedFlag ? (
          <div className="unauthorized-message" >מצטערים, אין לך גישה למשימה זו.</div>
        ) : (
          <>
            <h2 style={{ fontWeight: 'bold', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
              {this.state.task_name}
            </h2>
            <ValidationMessage
              taskValidation={this.state.taskValidation}
              initialCountdown={180}
              clearDataFetchInterval={this.clearDataFetchInterval}
            />
            <SignersList
              task_id={this.state.task_id}
              signersDetails={this.state.dataFromServer}
              signersCheckList={this.state.signersCheckList}
              attachmentLink={this.state.AttachementLink}
              document_id={this.state.document_id}
              REACT_APP_SERVER_URL={REACT_APP_SERVER_URL}
              refreshData={this.refreshData}
              isNextSignerBlocked={this.state.isNextSignerBlocked}
            />
            <h6 className={"signers"} style={{ marginBottom: '0px', marginTop: '12px', textAlign: 'center' }}>השלמות</h6>
            <SubTasksGrid
              isClientCommented={this.state.isClientCommented}
              subtasks={this.state.subtasks}
              REACT_APP_SERVER_URL={REACT_APP_SERVER_URL}
              refreshData={this.refreshData}
            />
            <h6 className={"signers"} style={{ marginBottom: '0px', marginTop: '12px', textAlign: 'center' }}>עדכונים</h6>
            <ChatWindow comments={this.state.comments} />
          </>
        )}
      </React.Fragment>
    );

  };

}

const apiData = [
  {
    email: "test@gmail.com",
    name: "Sender",
    phone: "test",
    display_name: "ממתינים לסיפריה",
    indexInSession: null,
    is_completed: true,
    url: null,
  },
];



export default App;